import { createFileRoute } from "@tanstack/react-router";

import { AdminSection } from "@/components/index/admin-section";
import { AudienceSection } from "@/components/index/audience-section";
import { CtaBanner } from "@/components/index/cta-banner";
import { HeroSection } from "@/components/index/hero-section";
import { LandingFooter } from "@/components/index/landing-footer";
import { PricingSection } from "@/components/index/pricing-section";
import { WorkflowSection } from "@/components/index/workflow-section";
import { createWebPageJsonLd, seo } from "@/lib/seo";
import * as m from "@/paraglide/messages";

export const Route = createFileRoute("/(landing)/")({
	component: LandingPage,
	head: ({ match }) => {
		const title = `AI ${m.hero_title()} | StudyOS`;
		const description = m.hero_subtitle();

		return seo({
			title,
			description,
			pathname: match.pathname,
			keywords: [
				"AI learning platform",
				"interactive study sessions",
				"AI quizzes",
				"AI flashcards",
				"StudyOS",
			],
			structuredData: createWebPageJsonLd({
				title,
				description,
				pathname: match.pathname,
			}),
		});
	},
});

function LandingPage() {
	return (
		<>
			<HeroSection />
			<WorkflowSection />
			<AdminSection />
			<AudienceSection />
			<PricingSection />
			<CtaBanner />
			<LandingFooter />
		</>
	);
}
